// extracted by mini-css-extract-plugin
module.exports = {"container":"_1IDmohxEuJ1tgnT9-QEr77","company":"_3tZ8YX5jdmrAwTBzXsOj5R","title":"RAK_wDc-IRvBLgYzJs5tZ","companies":"_1dQq258FmDTM_MqimT68lK"};